module.exports = __webpack_public_path__ + "static/media/gettape.dd833df2.png";